module.exports = ".badge {\n  width: 60px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/users/users.component.scss
// module id = ./src/app/views/users/users.component.scss
// module chunks = main